import { FC, ReactNode } from 'react';
import styles from './HeaderExternalSiteLinks.module.css';
import stylesMobile from './HeaderExternalSiteLinksMobile.module.css';
import { Icon } from '@kpa/kul';
import { useQuery } from '@tanstack/react-query';
import { userInfoQueryOptions } from '../../iam/userInfoQuery';
import { Kanaltyp } from '../../iam/userTypes';

type HeaderExternalSiteLinks = {
  mobile?: boolean;
};

const HeaderExternalSiteLinks: FC<HeaderExternalSiteLinks> = ({ mobile }): ReactNode => {
  const userInfo = useQuery(userInfoQueryOptions);

  if (userInfo.data?.kanalbehörigheter.length == 0) {
    return;
  }

  const GetButton = (kanal: Kanaltyp) => {
    const kanalbehörighet = userInfo.data?.kanalbehörigheter.find(w => w.kanaltyp === kanal);
    if (kanalbehörighet !== undefined) {
      return (
        <a href={kanalbehörighet.url} className={styles.headerButton} target="_blank" rel="noopener noreferrer">
          <div className={styles.icon}><Icon name={kanal == Kanaltyp.KppNkd ? 'IconCoinsGrow' : 'IconPig'} color="backgroundPrimary" size="large"></Icon></div>
          <div className={styles.content}>
            <div className={styles.title}>
              {kanal == Kanaltyp.KppNkd ? 'KPA Direkt' : 'Pensionsvalet'}
            </div>
          </div>
        </a>
      );
    }
  };

  const GetButtonMobile = (kanal: Kanaltyp) => {
    const kanalbehörighet = userInfo.data?.kanalbehörigheter.find(w => w.kanaltyp === kanal);
    if (kanalbehörighet !== undefined) {
      return (
        <a href={kanalbehörighet.url} className={stylesMobile.headerButton} target="_blank" rel="noopener noreferrer">
          <div className={stylesMobile.icon}><Icon name={kanal == Kanaltyp.KppNkd ? 'IconCoinsGrow' : 'IconPig'} color="backgroundPrimary" size="medium"></Icon></div>
          <div className={stylesMobile.content}>
            <div className={stylesMobile.title}>
              {kanal == Kanaltyp.KppNkd ? 'KPA Direkt' : 'Pensionsvalet'}
            </div>
          </div>
          <div className={stylesMobile.iconarrow}><Icon name="IconCaretRight" color="backgroundPrimary" size="medium"></Icon></div>
        </a>
      );
    }
  };

  return (
    <>
      {
        !mobile
          ? (
              <>
                {GetButton(Kanaltyp.KppNkd)}
                {GetButton(Kanaltyp.KppPv)}
              </>
            )
          : (
              <>
                {GetButtonMobile(Kanaltyp.KppNkd)}
                {GetButtonMobile(Kanaltyp.KppPv)}
              </>
            )
      }
    </>

  );
};

export default HeaderExternalSiteLinks;
